@if (flagEmoji) {
  {{ flagEmoji }}
} @else {
  <span class="fi fi-{{ countryCode.toLowerCase() }}"></span>
}
